module.exports = __webpack_public_path__ + "img/88.maintenance.ab20065e.svg";